import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'jit-report-question-fib-dropdown',
  templateUrl: './fib-dropdown.component.html',
  styleUrls: ['./fib-dropdown.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
  ],
})
class ReportQuestionFibDropdownComponent {
  
}

export {
  ReportQuestionFibDropdownComponent,
};
